import React, { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";

import MyAccountFilter from "../MyAccount/MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useParams } from "react-router-dom";

const DEFAULT_FILTER = { page: 1, limit: 10 };

const fromToLabel = (item) =>
  `${item?.createdByData?.username || "-"} -> ${item?.userData?.username || "-"}`;

const amountCell = (value, className) =>
  value ? (
    <span className={className}>{toFixedWithoutRounding(Math.abs(value))}</span>
  ) : (
    "-"
  );

const BankingLogs = () => {
  const { id } = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();

  const [filter, setFilter] = useState({
    ...DEFAULT_FILTER,
    user_id: !isEmpty(id) ? id : "",
  });
  const [data, setData] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.transactionLogs,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));

  const handleShowDefault = () => {
    const nextFilter = {
      ...DEFAULT_FILTER,
      user_id: !isEmpty(id) ? id : "",
    };
    setFilter(nextFilter);
    if (filter.page === nextFilter.page && filter.limit === nextFilter.limit) {
      getData(nextFilter);
    }
  };

  const handlePageChange = (newPage) =>
    setFilter((prev) => ({ ...prev, page: newPage }));

  const rows = data?.data || [];

  const totals = rows.reduce(
    (acc, item) => ({
      depositFromUpline:
        acc.depositFromUpline + Number(item?.depositFromUpline || 0),
      depositToDownline:
        acc.depositToDownline + Number(item?.depositToDownline || 0),
      wihtDrawByUpline:
        acc.wihtDrawByUpline + Number(item?.wihtDrawByUpline || 0),
      withDrawFromDownline:
        acc.withDrawFromDownline + Number(item?.withDrawFromDownline || 0),
    }),
    {
      depositFromUpline: 0,
      depositToDownline: 0,
      wihtDrawByUpline: 0,
      withDrawFromDownline: 0,
    },
  );

  return (
    <ng-component className="ng-star-inserted">
      <div className="full-wrap">
        <h2>Banking logs</h2>
        <div className="total_all">
          <span style={{ display: "flex", alignItems: "center" }}>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              value={filter.limit}
              onChange={handleLimitChange}
            >
              {" "}
              <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
            </select>
            <a
              style={{ marginBottom: "5px" }}
              id="getPL"
              className="btn-send"
              onClick={(e) => {
                e.preventDefault();
                handleShowDefault();
              }}
            >
              Show Default
            </a>
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="banking-logs"
          />
        </div>

        <div className="over-wrap" style={{ maxHeight: "calc(100% - 108px)" }}>
          <div className="table-responsive data-table">
            <table
              ref={tableRef}
              id="table_transfer"
              className="table01 tab-transfer tab-banking"
            >
              <tbody>
                <tr>
                  <th width="12%" className="align-L sort_asc">
                    Date/Time
                  </th>
                  <th width="13%" className="sort_asc">
                    Deposit by Upline
                  </th>
                  <th width="13%" className="sort_asc">
                    Deposit to Downline
                  </th>
                  <th width="13%" className="sort_asc">
                    Withdraw by Upline
                  </th>
                  <th width="13%" className="sort_asc">
                    Withdraw from Downline
                  </th>
                  <th width="13%" className="sort_asc">
                    Balance
                  </th>
                  <th width="13%" className="sort_asc">
                    Remark
                  </th>
                  <th width="20%" className="sort_asc">
                    From/To
                  </th>
                </tr>
              </tbody>

              <tbody id="content">
                {!isEmpty(rows) ? (
                  rows.map((item, key) => (
                    <tr key={key}>
                      <td className="td-uid">
                        {formatDate(item?.createdAt, user?.timeZone)}
                      </td>
                      <td id="siteCol">
                        {amountCell(item?.depositFromUpline, "")}
                      </td>
                      <td id="siteCol">
                        {amountCell(item?.depositToDownline, "")}
                      </td>
                      <td id="currencyTypeCol" style={{ color: "red" }}>
                        {amountCell(item?.wihtDrawByUpline, "red")}
                      </td>
                      <td id="currencyTypeCol" style={{ color: "red" }}>
                        {amountCell(item?.withDrawFromDownline, "red")}
                      </td>
                      <td id="balance">
                        {toFixedWithoutRounding(item?.newBalance1)}
                      </td>
                      <td id="availableBalance">Fund Transfer</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {/* {fromToLabel(item)} */}
                        {item?.formToData}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8}>No records found</td>
                  </tr>
                )}

                {!isEmpty(rows) && (
                  <tr className="total">
                    <td className="align-L">Total</td>
                    <td id="_totalDepositbyUpline">
                      <span>
                        {toFixedWithoutRounding(totals.depositFromUpline)}
                      </span>
                    </td>
                    <td id="_totalDepositbyDownline">
                      <span>
                        {toFixedWithoutRounding(totals.depositToDownline)}
                      </span>
                    </td>
                    <td id="_totalWithdrawUpline">
                      <span className="">
                        {toFixedWithoutRounding(totals.wihtDrawByUpline)}
                      </span>
                    </td>
                    <td id="_totalWithdrawDownline">
                      <span className="">
                        {toFixedWithoutRounding(totals.withDrawFromDownline)}
                      </span>
                    </td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {rows.length > 0 && data?.totalDocs > 0 && (
            <Pagination pagination={data} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </ng-component>
  );
};

export default BankingLogs;
